import {Tour} from "../Tour";
import {HintsGroup} from "../Hint";
import { i18n } from 'src/boot/i18n';

const tours = [
  {
    // Temporary deactivation
    // name: "SongPageTour",
    // steps: [
    //   {
    //     title: "La fiche morceau",
    //     intro: "Sur cette page, vous trouverez de nombreuses informations concernant les ingrédient musicaux du morceau."
    //   },
    //   {
    //     title: "La fiche morceau",
    //     intro: "Un morceau est structuré en différentes parties, dont certaines peuvent être répétées plusieurs fois Votre progression sur chacune de ces parties est affichée ici.",
    //     element: ".song-page-tour__structure"
    //   },
    //   {
    //     title: "La fiche morceau",
    //     intro: "Cet onglet vous permettra de découvrir ou réviser les accords du morceau.",
    //     element: ".song-page-tour__chords"
    //   },
    //   {
    //     title: "La fiche morceau",
    //     intro: "Certains schémas rythmiques se répètent au sein d'un morceau. Découvrez les en cliquant sur cet onglet.",
    //     element: ".song-page-tour__rhythms"
    //   }
    // ]
  }
] as Tour[];

const hints = [
  {
    name: "SongPageHintsListen",
    hints: [
      {
  hint: i18n.t('onboardingSongPageData.hints.listen'),
        element: ".song-page-hints__listen",
        hintPosition: "top-right"
      }
    ]
  },
  {
    name: "SongPageHintsLyrics",
    hints: [
      {
  hint: i18n.t('onboardingSongPageData.hints.lyrics'),
        element: ".song-page-hints__lyrics",
        hintPosition: "middle-left"
      }
    ]
  }
] as HintsGroup[];

export default {tours, hints};
